import * as React from 'react'
import { STATUS_COLORS } from '../../../constants/statusColors'

interface AgentOption {
  type: string
  name: string
}

interface KanbanFiltersProps {
  agents: AgentOption[]
  agentFilter: string
  dateFilter: string
  collapsedCancelled: boolean
  onAgentFilterChange: (value: string) => void
  onDateFilterChange: (value: string) => void
  onToggleCancelled: () => void
}

export const KanbanFilters: React.FC<KanbanFiltersProps> = ({
  agents,
  agentFilter,
  dateFilter,
  collapsedCancelled,
  onAgentFilterChange,
  onDateFilterChange,
  onToggleCancelled,
}) => (
  <div className="flex flex-wrap gap-3">
    <select
      value={agentFilter}
      onChange={e => onAgentFilterChange(e.target.value)}
      className="px-3 py-2 text-xs rounded-lg border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-900 text-gray-700 dark:text-gray-200"
    >
      <option value="all">Todos os agentes</option>
      {agents.map(agent => (
        <option key={agent.type} value={agent.type}>
          {agent.name}
        </option>
      ))}
    </select>
    <select
      value={dateFilter}
      onChange={e => onDateFilterChange(e.target.value)}
      className="px-3 py-2 text-xs rounded-lg border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-900 text-gray-700 dark:text-gray-200"
    >
      <option value="today">Hoje</option>
      <option value="yesterday">Ontem</option>
      <option value="7d">Últimos 7 dias</option>
      <option value="15d">Últimos 15 dias</option>
      <option value="30d">Últimos 30 dias</option>
      <option value="all">Qualquer data</option>
    </select>
    <button
      onClick={onToggleCancelled}
      className={`text-xs px-3 py-2 rounded-lg border transition ${
        collapsedCancelled
          ? 'text-gray-700 dark:text-gray-200 border-gray-200 dark:border-gray-700 hover:border-brand-400'
          : `${STATUS_COLORS.cancelled.text} ${STATUS_COLORS.cancelled.activeBorder} ${STATUS_COLORS.cancelled.activeBg}`
      }`}
    >
      {collapsedCancelled ? 'Mostrar cancelados' : 'Ocultar cancelados'}
    </button>
  </div>
)
